module.exports = __webpack_public_path__ + "img/wenti.9792ad69.png";